// Third-party bundle - matches Gulp thirdparty task
// This bundle includes all external vendor libraries

// jQuery FIRST - must be available globally before any other imports
import $ from 'jquery';
window.jQuery = window.$ = $;
globalThis.jQuery = globalThis.$ = $;
if (typeof global !== 'undefined') {
  global.jQuery = global.$ = $;
}

// Polyfills
import 'promise-polyfill/lib/polyfill';

// Utilities
import Cookies from 'js-cookie';
window.Cookies = Cookies;

// Load Foundation from local asset to comply with CSP
const foundationScript = document.createElement('script');
foundationScript.src = '/assets/js/foundation.min.js';
foundationScript.onload = function() {
  // Foundation should be available globally after loading
  if (typeof Foundation !== 'undefined') {
    window.Foundation = Foundation;
    console.log('Foundation loaded successfully from local asset:', typeof Foundation);
  } else if (typeof window.Foundation !== 'undefined') {
    console.log('Foundation available on window:', typeof window.Foundation);
  } else {
    console.error('Foundation not available after local load - checking for jQuery setup');
    // Foundation requires jQuery to be available globally
    if (typeof $ === 'undefined') {
      console.error('jQuery not available for Foundation');
    }
  }
};
foundationScript.onerror = function() {
  console.error('Failed to load Foundation from local asset');
  foundationRetryCount = maxFoundationRetries; // Stop retrying if script failed to load
};
document.head.appendChild(foundationScript);

// Media players
import Player from '@vimeo/player';
window.Vimeo = { Player };

// Loading spinners
import { Spinner } from 'spin.js';
import 'spin.js/spin.css';
window.Spinner = Spinner;

console.log('Thirdparty bundle loaded - jQuery:', typeof $, 'Foundation:', typeof Foundation);

// Signal that thirdparty bundle is ready
window.thirdpartyReady = true;
window.dispatchEvent(new CustomEvent('thirdpartyReady'));

// Initialize Foundation - wait for it to load first
let foundationRetryCount = 0;
const maxFoundationRetries = 40; // 2 seconds max wait

function initializeFoundation() {
  foundationRetryCount++;
  
  if (typeof Foundation !== 'undefined') {
    $(document).foundation();
    console.log('Foundation initialized');
  } else if (foundationRetryCount < maxFoundationRetries) {
    console.log('Waiting for Foundation to load...');
    setTimeout(initializeFoundation, 50);
  } else {
    console.warn('Foundation failed to load after 2 seconds, continuing without it');
    // App can still function without Foundation for basic functionality
  }
}

$(document).ready(function() {
  console.log('Document ready - Foundation:', typeof Foundation);
  initializeFoundation();
});